import { render, staticRenderFns } from "./TradeWidget.vue?vue&type=template&id=6106a6ea&scoped=true&"
import script from "./TradeWidget.vue?vue&type=script&lang=js&"
export * from "./TradeWidget.vue?vue&type=script&lang=js&"
import style0 from "./TradeWidget.vue?vue&type=style&index=0&id=6106a6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106a6ea",
  null
  
)

export default component.exports